import { NavLink } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

export default function MobileMenu({ id, lang, onClose }) {
  return (
    // Capped to the viewport and scrollable, so at 200–400% zoom every menu
    // item can be scrolled to (WCAG 1.4.10 Reflow / 2.4.11 Focus Not Obscured).
    <div id={id} className="site-mobile-menu md:hidden max-h-[calc(100dvh-5rem)] overflow-y-auto overscroll-contain bg-white dark:bg-dark-900 border-b border-gray-200 dark:border-dark-700 py-4 px-6 animate-in">
      <nav aria-label={lang.ui.mainNav} className="flex flex-col gap-1 mb-4">
        {lang.menu.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.slug === ''}
            onClick={onClose}
            className={({ isActive }) =>
              `nav-link block ${isActive ? 'active' : ''}`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </nav>
      <div className="pt-4 border-t border-gray-200 dark:border-dark-700">
        <LanguageSwitcher />
      </div>
    </div>
  );
}
